import axiosInstance from '../../utils/axios';

export const supportService = {
  // Fetch Agent Profile info
  getAgentProfile: async () => {
    try {
      const response = await axiosInstance.get('/agent/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch agent profile' };
    }
  },

  // Fetch all active traveller chats for agent
  getTravellerChats: async () => {
    try {
      const response = await axiosInstance.get('/chat/agent/all');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch traveller chats' };
    }
  },

  // Fetch specific conversation thread & voucher info
  getChatThread: async (bookingId, guestName) => {
    try {
      const cleanId = (bookingId || '').toLowerCase().trim();
      const encodedGuest = encodeURIComponent(guestName || '');
      const response = await axiosInstance.get(`/chat/agent/thread/${cleanId}?guestName=${encodedGuest}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to load chat conversation' };
    }
  },

  // Send message to traveller (with optional image attachment)
  sendTravellerMessage: async (bookingId, formData) => {
    try {
      const cleanId = (bookingId || '').toLowerCase().trim();
      const response = await axiosInstance.post(`/chat/agent/message/${cleanId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to send message' };
    }
  },

  // Fetch ticket history
  getTickets: async () => {
    try {
      const response = await axiosInstance.get('/agent/tickets/history');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch tickets' };
    }
  },

  // Raise a new support ticket with Trrip Helpdesk
  createTicket: async (formData) => {
    try {
      const response = await axiosInstance.post('/agent/tickets', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to raise ticket' };
    }
  },

  // Send reply message to a support ticket
  sendTicketMessage: async (ticketId, formData) => {
    try {
      const response = await axiosInstance.post(`/agent/tickets/${ticketId}/message`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to send ticket reply' };
    }
  }
};

export default supportService;
